"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withdraw = exports.nonEVMSwap = void 0;
const { waitForConfirmation, default: algosdk, ALGORAND_MIN_TX_FEE, } = require("algosdk");
var ByteBuffer = require("bytebuffer");
function nonEVMSwap(sourceAddress, tokenAddress, amount, targetToken, targetAddress, targetNetwork, dispatch) {
    return __awaiter(this, void 0, void 0, function* () {
        const { AlgoSigner } = window;
        // Setup AlgodClient Connection
        // Setup AlgodClient Connection
        const algodToken = "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa";
        const algodServer = "http://3.145.206.208";
        const algodPort = 4001;
        let algodClient = new algosdk.Algodv2(algodToken, algodServer, algodPort);
        // await AlgoSigner.connect({
        //   ledger: "TestNet",
        // });
        // const accts = await AlgoSigner.accounts({
        //   ledger: "TestNet",
        // });
        // const sender = accts[who]["address"];
        // Contract Address
        let smartContract = "ET3QWGXO5Z3HC55J7QXKBUWA2K75VZYRGUSB7YDSNO3ZNF254LKZMBQTIY";
        // get node suggested parameters (sp)
        let suggestedParams = yield algodClient.getTransactionParams().do();
        suggestedParams.fee = ALGORAND_MIN_TX_FEE * 2;
        suggestedParams.flatFee = true;
        //python3 -c "import algosdk.encoding as e; print(e.encode_address(e.checksum(b'appID'+(79584368).to_bytes(8, 'big'))))"
        let index = 107308165;
        // let token_address = 81317600;
        let token_address = tokenAddress;
        let revocationTarget = undefined;
        let closeRemainderTo = undefined;
        let note = undefined;
        // let account = [];
        // let foreignApp = [];
        let foreignAssets = [];
        foreignAssets.push(token_address);
        let action = "swap";
        // let amount = 500;
        // let target_token = "A719b8aB7EA7AF0DDb4358719a34631bb79d15Dc";
        let target_token = targetToken;
        // let target_network = 56;
        let target_network = targetNetwork;
        // let target_address = "A719b8aB7EXYZDDb4358719a34631b930X39Ax";
        let target_address = targetAddress;
        let appArgs = [];
        appArgs.push(new Uint8Array(Buffer.from(action)));
        appArgs.push(algosdk.encodeUint64(token_address));
        appArgs.push(algosdk.encodeUint64(amount));
        appArgs.push(algosdk.encodeUint64(target_network));
        appArgs.push(new Uint8Array(Buffer.from(target_token)));
        appArgs.push(new Uint8Array(Buffer.from(target_address)));
        // Transaction to stake token
        let txnStake = algosdk.makeAssetTransferTxnWithSuggestedParams(sourceAddress, smartContract, closeRemainderTo, revocationTarget, amount, note, token_address, suggestedParams);
        // console.log(txnStake)
        // create unsigned transaction
        let txnCall = algosdk.makeApplicationNoOpTxn(sourceAddress, suggestedParams, index, appArgs);
        // console.log(txn)
        // Group the paymntTransferStakte Txn and AppCall
        let txnGroup = [txnStake, txnCall];
        algosdk.assignGroupID(txnGroup);
        let binaryTxs = [txnStake.toByte(), txnCall.toByte()];
        let base64Txs = binaryTxs.map((binary) => AlgoSigner.encoding.msgpackToBase64(binary));
        let signedTxs = yield AlgoSigner.signTxn([
            {
                txn: base64Txs[0],
            },
            {
                txn: base64Txs[1],
            },
        ]);
        let binarySignedTxs = signedTxs.map((tx) => AlgoSigner.encoding.base64ToMsgpack(tx.blob));
        const tx = yield algodClient.sendRawTransaction(binarySignedTxs).do();
        dispatch(tx.txId);
        // Wait for transaction to be confirmed
        yield waitForConfirmation(algodClient, tx.txId, 10);
        // response display
        let transactionResponse = yield algodClient
            .pendingTransactionInformation(tx.txId)
            .do();
        console.log({ transactionResponse });
        console.log("Swapped to the BSC Network [AssetID]: ", transactionResponse["txn"]["txn"]["xaid"]);
        if (transactionResponse["global-state-delta"] !== undefined) {
            console.log("Global State updated:", transactionResponse["global-state-delta"]);
        }
        if (transactionResponse["local-state-delta"] !== undefined) {
            console.log("Local State updated:", transactionResponse["local-state-delta"]);
        }
        return tx.txId;
    });
}
exports.nonEVMSwap = nonEVMSwap;
// withdraw();
const withdraw = (sender, tokenAddress, amount, message, messageHash, signature, payee, salt, dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { AlgoSigner } = window;
    const algodToken = "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa";
    const algodServer = "http://3.145.206.208";
    const algodPort = 4001;
    let algodClient = new algosdk.Algodv2(algodToken, algodServer, algodPort);
    let suggestedParams = yield algodClient.getTransactionParams().do();
    suggestedParams.fee = ALGORAND_MIN_TX_FEE * 12;
    suggestedParams.flatFee = true;
    let index = 107308165;
    let taxIndex = 107194846;
    let token_address = tokenAddress;
    // GAJPADR5Y3ESQMP2LRGYKEADLBW6HXS5E3MDTQ7PCQS76EZTFJ4ZYH2VIE
    // RPWOPFEMNLC3H3KMU7W6T2FJ637RD5TF4X46DM5ECZPQRECUTGXM57YEIE
    // OADKEO5L3QGMWWSIZJTVOZ64PVDMYK2ETIP65ESH22YSCEFTAE5B5IAKAQ
    // IP2SEOTPZR3E6MVUD7MW4JJND7EPKVWTLCYA3ZOJ55PC6RXCKJ3KT2DMQ4
    // UWD26UD3SFGGLSHGEFEZFD7A5GFYCJNR36O6OSI3LB5XPCGQWWKL6YVDHI
    let account = [
        "OADKEO5L3QGMWWSIZJTVOZ64PVDMYK2ETIP65ESH22YSCEFTAE5B5IAKAQ",
        "RPWOPFEMNLC3H3KMU7W6T2FJ637RD5TF4X46DM5ECZPQRECUTGXM57YEIE",
        "GAJPADR5Y3ESQMP2LRGYKEADLBW6HXS5E3MDTQ7PCQS76EZTFJ4ZYH2VIE",
        "L6QDYEA4FKKB23YDOFCKI6DK3BJYFYGWXMYUXR3B3MT6MCLG222J3IJGLY",
    ];
    let foreignApp = [];
    foreignApp.push(taxIndex);
    let foreignAssets = [];
    foreignAssets.push(token_address);
    // withdraw_token(_token,_amount, _receiver, salt, signature),
    let action = "withdraw";
    // let payee = "0x0Bdb79846e8331A19A65430363f240Ec8aCC2A52";
    // let amount = 5;
    // let signature = "104477af5625a433e22adbbb449cad475f181bd6b49681fdb1a31890a834fa5945a03008f5fd9b36ed2943f74a0109bce2d01f62a34dcef672963f76cf6d26121b";
    let signByte = ByteBuffer.fromHex(signature, true, undefined);
    let signatureBuffer = signByte.buffer;
    // Message (hash) to be used for verification of arguments
    // let msg = "7396f0b1e79efb58160018f1663d1503d7f96508ca60aa2970e8280b5c9f497c"
    let msgByte = ByteBuffer.fromHex(message, true, undefined);
    let msgBuffer = msgByte.buffer;
    // Message Hash (hash) to be used along with signature for recovery of signer
    // let msgHash = "8ff8bcfd169416dd06de3debb703ec52cdda72d3e612d259e894839111ea0595"
    let msgHashByte = ByteBuffer.fromHex(messageHash, true, undefined);
    let msgHashBuffer = msgHashByte.buffer;
    // let salt = "fa393a47b05c66a643f56a3caeda7d03b950ae0c";
    let algoChainID = 26261;
    let appArgs = [];
    appArgs.push(new Uint8Array(Buffer.from(action)));
    appArgs.push(algosdk.encodeUint64(token_address));
    appArgs.push(new Uint8Array(Buffer.from(payee)));
    appArgs.push(algosdk.encodeUint64(amount));
    appArgs.push(new Uint8Array(Buffer.from(salt)));
    appArgs.push(new Uint8Array(signatureBuffer));
    appArgs.push(algosdk.encodeUint64(algoChainID));
    appArgs.push(new Uint8Array(msgBuffer));
    appArgs.push(new Uint8Array(msgHashBuffer));
    let recipient = sender;
    let revocationTarget = undefined;
    let note = undefined;
    // CloseReaminerTo is set to undefined as
    // we are not closing out an asset
    let closeRemainderTo = undefined;
    // amount = 0;
    // signing and sending "txn" allows sender to begin accepting asset specified by creator and index
    let txnOptin = algosdk.makeAssetTransferTxnWithSuggestedParams(sender, recipient, closeRemainderTo, revocationTarget, amount, note, token_address, suggestedParams);
    // create unsigned transaction
    let txnWithdraw = algosdk.makeApplicationNoOpTxn(sender, suggestedParams, index, appArgs, account, foreignApp, foreignAssets);
    // Group the paymntTransferStakte Txn and AppCall
    let txnGroup = [txnOptin, txnWithdraw];
    algosdk.assignGroupID(txnGroup);
    let binaryTxs = [txnOptin.toByte(), txnWithdraw.toByte()];
    let base64Txs = binaryTxs.map((binary) => AlgoSigner.encoding.msgpackToBase64(binary));
    let signedTxs = yield AlgoSigner.signTxn([
        {
            txn: base64Txs[0],
        },
        {
            txn: base64Txs[1],
        },
    ]);
    let binarySignedTx = signedTxs.map((tx) => AlgoSigner.encoding.base64ToMsgpack(tx.blob));
    console.log(binarySignedTx);
    // submit the transaction
    const response = yield algodClient.sendRawTransaction(binarySignedTx).do();
    console.log("Raw transaction submitted: ", response);
    dispatch(response === null || response === void 0 ? void 0 : response.txId);
    return response;
});
exports.withdraw = withdraw;
//# sourceMappingURL=algorandHelper.js.map